import { AfterViewInit, Component, ElementRef, QueryList, ViewChildren } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, ValidationErrors, Validators } from '@angular/forms';
import { of } from 'rxjs';
import { catchError, filter, map, tap } from 'rxjs/operators';
import { BaseComponent } from '../../shared/base-components/base.component';
import { ModalSize } from '../../shared/services/modal/mvd-modal.enum';
import { MvdModalService } from '../../shared/services/modal/mvd-modal.service';
import { AppSettings } from '../../shared/settings/app-settings.model';
import { NotificationCreationModel } from '../models/notification-creation.model';
import { NotificationService } from '../services/notification.service';
import { TeamSelectionData, TeamSelectionWindow } from './team-selection-modal.component';
// TODO: Remove dependency on jquery
import * as $ from 'jquery';

@Component({
    selector: 'create-notification',
    templateUrl: './create-notification.html'
})
export class CreateNotificationComponent extends BaseComponent implements AfterViewInit {
    public notificationChannels: any = new Array();
    private selectedTeams: any = new Array();
    public selectedTeamNames: string;
    private customerNumberIds: string;
    public users: any[] = new Array();
    public notificationCreationForm: UntypedFormGroup;
    @ViewChildren('notificationChannelChildren') private notificationChannelChildren: QueryList<ElementRef>;
    public readyToDisplayValidationMessages = false;
    private isUserType = true;
    public notification: NotificationCreationModel = new NotificationCreationModel();

    constructor(
        private notificationService: NotificationService,
        public fb: UntypedFormBuilder,
        private appSettings: AppSettings,
        private modalService: MvdModalService
    ) {
        super();
        this.notificationService.getNotificationChannels().subscribe(result => {
            const modifiedResult: Object[] = result.result;
            modifiedResult.forEach(item => {
                item['okToDisplay'] = true;
            });
            this.notificationChannels = modifiedResult;
        });
        this.notificationService.getUsersForBusinessUnit().subscribe(result => {

            var businessUnits = result.result;

            for (var i = 0; i < businessUnits.length; i++) {
                this.users.push({ label: businessUnits[i].firstName + ' ' + businessUnits[i].lastName, value: businessUnits[i].id });
            }
        });
    }

    public ngOnInit() {
        // TODO: The ngModel form bindings were removed but could not be tested because the feature has been disabled. This will need
        // to be tested when this component is revived in the future.
        this.notificationCreationForm = this.fb.group({
            'messageText': ['', Validators.required],
            'expirationDate': ['', Validators.required],
            'customerNumberId': [''],
            'channel': ['', Validators.required],
            'userLoginIds': [[]]
        },
        {
            // validator: Validators.compose(validatorArr)
        });
    }

    public ngAfterViewInit() {
        const item = this.notificationChannelChildren.forEach(channel => console.log(channel));
    }

    public enableCustomerField = (): boolean => true;

    public customerSelected = (event: any): void => {
        this.customerNumberIds = event != null ? event['customerNumber'] : -1;
    };

    public toButtonClick = ($event): void => {
        $event.stopPropagation();

        const data = new TeamSelectionData(this.selectedTeams);
        const dialogRef = this.modalService.open(TeamSelectionWindow, data, ModalSize.Small);

        dialogRef.afterClosed()
            .pipe(filter(result => !!result))
            .subscribe(
                result => {
                    this.selectedTeams = result;
                    this.selectedTeamNames = result.map(x => x.teamDisplayValue).join('; ');
                    this.notification.audienceTeamIds = result.map(x => x.id);

                    this.notificationCreationForm.markAsDirty();
                    this.notificationCreationForm.markAsTouched();
                    this.notificationCreationForm.updateValueAndValidity();
                },
                cancellation => { }
            );
    };

    public channelSelectionMade = ($event): void => {
        const selectedValue = $event.target.value;
        const channelObject = this.notificationChannels.find(item => item.notificationChannelTypeValue.toLowerCase() == selectedValue.toLowerCase());

        if (channelObject) {
            if ($event.target['checked']) {
                this.notification.deliveryChannelTypeIds.push(channelObject['id']);
            } else { // Deselected
                var index = this.notification.deliveryChannelTypeIds.indexOf(channelObject['id']);
                this.notification.deliveryChannelTypeIds.splice(index, 1);
            }
        }

        this.notificationCreationForm.controls.channel.setValue(this.notification.deliveryChannelTypeIds);
        this.notificationCreationForm.markAsDirty();
        this.notificationCreationForm.markAsTouched();
        this.notificationCreationForm.updateValueAndValidity();
    };

    public enableExpirationDate = (): boolean => {
        const result = this.notification.deliveryChannelTypeIds.filter(x => x == 1 || x == 2).length > 0;

        if (result) {
            this.notificationCreationForm.controls['expirationDate'].enable();
        } else {
            this.notificationCreationForm.controls['expirationDate'].disable();
        }

        return result;
    };

    public getFormValidationErrors = (): number => {
        let errorCount = 0;

        Object.keys(this.notificationCreationForm.controls).forEach(key => {
            const controlErrors: ValidationErrors = this.notificationCreationForm.get(key)['errors'];
            if (controlErrors != null) {
                Object.keys(controlErrors).forEach(keyError => {
                    errorCount += 1;
                    // console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                });
            }
        });

        return errorCount;
    };

    public onSubmit = (event): void => {
        this.readyToDisplayValidationMessages = false;

        if (0 != this.getFormValidationErrors()) {
            this.readyToDisplayValidationMessages = true;
            return;
        }

        this.clearValidation();
        this.notification.customerNumberIds = new Array();
        if (this.customerNumberIds) {
            this.notification.customerNumberIds.push(parseInt(this.customerNumberIds));
        }
        // TODO: add enum
        // TODO: Should we always add the default MessageTitle???
        // NOTE: Add all notification channel type ids that require a MessageTitle here so the default MessageTitle is added
        if ($.inArray(3, this.notification.deliveryChannelTypeIds) >= 0) {
            this.notification.message.messageTitle = this.appSettings.notification.defaultNotificationMessageTitle;
        }

        this.notification.message.messageText = this.notificationCreationForm.get('messageText').value;
        this.notification.message.expirationDate = this.notificationCreationForm.get('expirationDate').value;
        this.notification.userLoginIds = this.notificationCreationForm.get('userLoginIds').value;

        if (this.notification.deliveryChannelTypeIds.length > 0) {
            if (!this.isUserType) {
                this.hasPrimaryEmailOrSMSChannel();
            } else {
                this.saveNotificationStandard();
            }
        }
    };

    public saveNotificationStandard = (message: string = undefined): void => {
        const title = 'Notification Creation';
        this.notificationService.saveNotification(this.notification)
            .pipe(
                tap(() => this.showValidationComponent = false),
                map(() => message ? message : 'The notification was created successfully.'),
                catchError(err => {
                    this.handleValidationResult(err);
                    return of('Notification creation failed');
                })
            )
            .subscribe(message => this.displayNotification(message, title));
    };

    public saveNotificationQueued = (): void => {
        this.saveNotificationStandard('The notification was added to the queue.');
    };

    public getNotificationChannel = (channelName: string): any => this.notificationChannels.find((c) => c.notificationChannelTypeValue == channelName);

    public noContactAvailable = (type: string): void => {
        const message = `Notification creation failed, no available contact for ${type}.`;
        const title = 'Notification Creation';
        this.modalService.alert().title(title).body(message).open(ModalSize.Small);
    };

    public hasPrimaryEmailOrSMSChannel = (): void => {
        const email = this.notification.deliveryChannelTypeIds.find((t) => {
            const channel = this.getNotificationChannel('Email');
            return t == channel.id;
        });
        const sms = this.notification.deliveryChannelTypeIds.find((t) => {
            const channel = this.getNotificationChannel('Text');
            return t == channel.id;
        });

        if (email) {
            this.notificationService.getBestAvailableEmail(this.notification.customerNumberIds[0]).subscribe((success) => {
                if (!success.result) {
                    this.noContactAvailable('Email');
                } else if (sms) {
                    this.notificationService.getBestAvailableSms(this.notification.customerNumberIds[0]).subscribe((success) => {
                        if (!success.result) {
                            this.noContactAvailable('Text');
                        } else {
                            this.saveNotificationQueued();
                        }
                    });
                } else {
                    this.saveNotificationQueued();
                }
            });
        } else if (sms) {
            this.notificationService.getBestAvailableSms(this.notification.customerNumberIds[0]).subscribe((success) => {
                if (!success.result) {
                    this.noContactAvailable('Text');
                } else {
                    this.saveNotificationQueued();
                }
            });
        } else {
            this.saveNotificationStandard();
        }
    };

    public setReceipientType = (type: boolean): void => {
        this.isUserType = type;
        this.notification.deliveryChannelTypeIds = [];

        this.notificationChannelChildren.forEach(item => {
            item.nativeElement.checked = false;
        });
    };

    public getUserType = (): boolean => this.isUserType;

    public canDisplay = (channel: any): boolean => {
        if (channel) {
            if (this.isUserType) {
                return (channel.notificationChannelTypeValue == 'Email' || channel.notificationChannelTypeValue == 'TextMessage') ? false : true;
            } else {
                return (channel.notificationChannelTypeValue == 'Alert') ? false : true;
            }
        }
    };

    private displayNotification(message, title) {
        this.modalService.alert().title(title).body(message).open(ModalSize.Small);
    }
}
